import React from 'react';

const inputClassName =
  'px-4 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500';

const FormField = ({ field, value, onChange }) => {
  const {
    name,
    label,
    type = 'text',
    required,
    options = [],
    placeholder,
    rows = 3,
    colSpan,
  } = field;

  const wrapperClass = colSpan === 2 ? 'flex flex-col col-span-2' : 'flex flex-col';

  if (type === 'checkbox') {
    return (
      <div className={`${wrapperClass} justify-center`}>
        <label className="flex items-center gap-2 text-gray-700 text-sm font-bold">
          <input
            type="checkbox"
            name={name}
            checked={!!value}
            onChange={onChange}
            className="h-4 w-4"
          />
          {label}
        </label>
      </div>
    );
  }

  if (type === 'select') {
    return (
      <div className={wrapperClass}>
        <label className="block text-gray-700 text-sm font-bold mb-2">{label}</label>
        <select
          name={name}
          value={value ?? ''}
          onChange={onChange}
          className={inputClassName}
          required={required}
        >
          <option value="" disabled>
            {placeholder || `Select ${label}`}
          </option>
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>
    );
  }

  if (type === 'textarea') {
    return (
      <div className={wrapperClass}>
        <label className="block text-gray-700 text-sm font-bold mb-2">{label}</label>
        <textarea
          name={name}
          value={value ?? ''}
          onChange={onChange}
          rows={rows}
          className={inputClassName}
          required={required}
          placeholder={placeholder}
        />
      </div>
    );
  }

  return (
    <div className={wrapperClass}>
      <label className="block text-gray-700 text-sm font-bold mb-2">{label}</label>
      <input
        type={type}
        name={name}
        value={value ?? ''}
        onChange={onChange}
        className={inputClassName}
        required={required}
        placeholder={placeholder}
      />
    </div>
  );
};

export default FormField;
export { inputClassName };
